import { alpha, Theme } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export default {
    tileViewContainer: {
        overflowY: 'auto',
        position: 'relative',
        height: '100%',

        //Embedded tile view
        '&:not(.tile-view-container--embedded)': {
            px: '19px',
        },

        '.tile-list-holder': {
            position: 'relative',
        },

        //Tile view
        '&.tile-view-container--tile': {
            pb: 3,
            '&.tile-view-container--untitled': {
                pt: 3,
            },
            '.tile-list-section__title': {
                position: 'absolute',
                overflow: 'visible',
                padding: '23px 0 11px 5px',
                width: '100%',
            },
            '.tile-list-section__title-text': {
                color: (theme: Theme) => theme.componentSettings.tile.sectionTitleTextColor,
                fontSize: (theme: Theme) => theme.typography.heading.fontSize,
                fontStyle: (theme: Theme) => theme.typography.heading.fontStyle,
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                paddingBottom: '5px',
                borderBottom: (theme: Theme) =>
                    `1px solid ${alpha(theme.componentSettings.tile.sectionTitleDividerColor, 0.4)}`,
                fontWeight: (theme: Theme) => theme.typography.heading.fontWeight,
                fontFamily: (theme: Theme) => theme.typography.heading.fontFamily,
                textTransform: (theme: Theme) => theme.typography.heading.textTransform,
            },
            '.tile-element': {
                position: 'absolute',
                margin: (theme: Theme) => theme.size.pxValue(theme.componentSettings.tile.margin),
            },
        },

        //List view
        '&.tile-view-container--list': {
            pt: 3,
            '.tile-list-section__title': {
                position: 'absolute',
                overflow: 'visible',
                padding: '8px 12px',
                width: '100%',
                backgroundColor: (theme: Theme) => useBlendColors(alpha(theme.palette.primary.main, 0.06)),
            },
            '.tile-list-section__title-text': {
                color: 'primary.main',
                fontWeight: '600',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
            },
            '.tile-element': {
                position: 'absolute',
            },
        },

        //Multi list view
        '&.tile-view-container--multi-list': {
            pt: 3,

            '.tile-list-section': {
                width: '100%',
                backgroundColor: (theme: Theme) => theme.palette.background.default,
            },
            '.tile-list-section__title': {
                backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.08),
                color: 'primary.main',
                fontWeight: 600,
                p: 1,
                borderRadius: 1,
                '&.tile-list-section__title--clickable': {
                    cursor: 'pointer',
                },
            },
            '.tile-list-section__title-icon': {
                display: 'inline-flex',
                mr: 1,
                fontSize: '16px',
            },

            '.tile-list-divider': {
                height: 'auto',
                borderColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.16),
            },
        },

        //Some fix, need review cases
        '&.tile-view-container--remove-padding': {
            pt: '0 !important',
        },
    },
    emptyMessageWrapper: {
        minHeight: '100%',
        '&.empty-message-wrapper--default': {
            justifyContent: 'center',
            pt: 3,
        },
        '&.empty-message-wrapper--custom': {
            height: '100%',
        },
        '.tile-view-container--remove-padding &': {
            pt: '0 !important',
        },
        '.empty-message-wrapper__custom-message-indent': {
            flexShrink: 10,
            height: '260px',
        },
        '.empty-message-wrapper__custom-message-holder': {
            flexGrow: 1,
            py: 3,
            mb: -3,
        },
        '.default-empty-message': {
            textAlign: 'center',
            py: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',

            '&__icon-holder': {
                display: 'inline-flex',
            },
            '&__icon': {
                fontSize: '32px',
                color: (theme: Theme) => alpha(theme.palette.text.primary, 0.4),
            },
            '&__text': {
                pt: 1.5,
                maxWidth: '185px',
            },
        },
    },
    emptyMessageContent: {
        borderRadius: '3px',
        border: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
        px: 3,
        py: 1.5, //1.5 from p inside content
        boxShadow: (theme: Theme) => `0px 8px 24px 0px ${alpha(theme.palette.text.primary, 0.08)}`,
        backgroundColor: 'background.default',
        '&.empty-message-wrapper__custom-message': {
            m: '0 10%',
        },
        '&.empty-message-wrapper__default-message': {
            alignSelf: 'center',
            minWidth: '344px',
        },
    },
};
